import React, { useEffect, useState } from "react";
import { Grid, Typography } from "@mui/material";
import CustomTextInput from "../../../components/HrManagements/CustomInput";
import SimpleDatePicker from "../../../components/HrManagements/SimpleDatePicker";
import CustomSelect from "../../../components/HrManagements/CustomSelect";
import { CustomBottom } from "../../../components/HrManagements/CustomBottom";
import { Box } from "@mui/material";
import { useSearchParams, useNavigate } from "react-router-dom";
import { API_AXIOS } from "../../../http/interceptor";
import Apis from "../../../utils/apis";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import FileUpload from "../../../components/FileUpload";

const visaOption = [
  { value: "visit", label: "Visit" },
  { value: "employment", label: "Employment" },
  { value: "sponsor", label: "Sponsor" },
];

const UserIdProof = ({ onNext, onPrev, onComplete, user, isAdmin }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const id = searchParams.get("id");
  const [loading, setLoading] = useState(false);
  const [uploadStates, setUploadStates] = useState({});
  const uploadBlocked = Object.values(uploadStates).some(state => state.loading || state.error);
  const uploadProps = (field) => ({
    name: field,
    multiple: true,
    maxFiles: 5,
    uploadContext: { userId: id, token },
    disabled: loading || checkDisable(field),
    onUploadStatusChange: (state) => setUploadStates(previous => ({ ...previous, [field]: state })),
  });
  const token = searchParams.get("token");
  const [passportFile, setPassportFile] = useState([]);
  const [visaFile, setVisaFile] = useState([]);
  const [resume, setResume] = useState([]);
  const [emiratesId, setEmiratesId] = useState([]);
  const [pancard, setPancard] = useState([]);
  const [aadharCard, setAadharCard] = useState([]);
  const [sscDuc, setSscDuc] = useState([]);
  const [hscDuc, setHscDuc] = useState([]);
  const [degreeCertificate, SetDegreeCertificate] = useState([]);

  const [values, setValues] = useState({
    passport: {
      passNumber: "",
      passDateOfIssue: null,
      passExpiry: null,
    },
    visa: {
      vType: "",
      vExpiry: null,
    },
  });

  useEffect(() => {
    setValues((state) => ({
      passport: {
        passNumber: user?.passport?.passNumber || "",
        passDateOfIssue: dayjs(user?.passport?.passDateOfIssue) || "",
        passExpiry: dayjs(user?.passport?.passExpiry) || "",
      },
      visa: {
        vType: user?.visa?.vType || "",
        vExpiry: dayjs(user?.visa?.vExpiry) || "",
      },
    }));
  }, [user]);

  const handleSelcted = (event) => {
    const selectedVisa = event.target.value;
    setValues((prevValues) => ({
      ...prevValues,
      visa: {
        ...prevValues.visa,
        vType: selectedVisa,
      },
    }));
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const [nestedObject, nestedProperty] = name.split(".");
    setValues((prevValues) => ({
      ...prevValues,
      [nestedObject]: {
        ...prevValues[nestedObject],
        [nestedProperty]: value,
      },
    }));
  };

  const handleSummit = async () => {
    try {
      const userIdData = {};
      user?.isEditable?.forEach((el) => {
        if (!!values[el]) {
          userIdData[el] = values[el];
        } else {
          let noKey = ["passport", "visa"];
          noKey?.forEach((x) => {
            for (const key in values[x]) {
              if (el === key) {
                let dd = {
                  [el]: values[x][key],
                };
                userIdData[x] = { ...userIdData[x], ...dd };
              }
            }
          });
        }
      });

      let updatingData = !user?.isFilled || isAdmin ? values : userIdData;
      if (uploadBlocked || loading) return;
      const documents = Object.fromEntries(Object.entries({
        passportFile, visaFile, resume, emiratesId, pancard, aadharCard,
        sscDuc, hscDuc, degreeCertificate,
      }).filter(([, references]) => references.length > 0));
      setLoading(true);
      const { data } = await API_AXIOS.post(
        `${Apis.updateUser}/${id}`,
        { data: JSON.stringify(updatingData), token, finalStage: true, documents },
        {
          ...(token ? { headers: { "x-invitation-token": token } } : {}),
          timeout: 30000,
        },
      );
      if (data.reviewEmailSent === false) {
        toast.warning(data.message);
      } else {
        toast.success(data.message);
      }
      if (token) {
        onComplete();
      } else {
        navigate(`/HrManagement/userDetails/${id}`);
      }
    } catch (err) {
      console.log(err);
      const message = err.response?.data;
      toast.error(typeof message === "string" ? message : message?.message || err.message || "Submission failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const checkDisable = (key) => {
    if (isAdmin) return false;
    return user?.isFilled && !user?.isEditable?.includes(key);
  };

  return (
    <>
      <Grid container rowSpacing={4} columnSpacing={4} mt={4}>
        <Grid item xs={12} sm={12} md={12}>
          <Typography
            sx={{
              color: "#202020",
              fontSize: "20px",
              fontWeight: "600",
            }}
          >
            ID PROOF
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <CustomTextInput
            label={"Passport Number"}
            name="passport.passNumber"
            value={values.passport.passNumber}
            onChange={handleInputChange}
            placeholder={"Passport Number"}
            disabled={checkDisable("passNumber")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <SimpleDatePicker
            label={"Issue Date"}
            value={values.passport.passDateOfIssue}
            onChange={(newValue) =>
              setValues((prevValues) => ({
                ...prevValues,
                passport: {
                  ...prevValues.passport,
                  passDateOfIssue: newValue,
                },
              }))
            }
            disabled={checkDisable("passDateOfIssue")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <SimpleDatePicker
            label={"Expiry Date"}
            value={values.passport.passExpiry}
            onChange={(newValue) =>
              setValues((prevValues) => ({
                ...prevValues,
                passport: {
                  ...prevValues.passport,
                  passExpiry: newValue,
                },
              }))
            }
            disabled={checkDisable("passExpiry")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <CustomSelect
            value={values?.visa?.vType}
            handleChange={handleSelcted}
            label="Visa Type"
            items={visaOption}
            disabled={checkDisable("vType")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <SimpleDatePicker
            label={"Visa Expiry Date"}
            value={values.visa?.vExpiry}
            onChange={(newValue) =>
              setValues((prevValues) => ({
                ...prevValues,
                visa: {
                  ...prevValues.visa,
                  vExpiry: newValue,
                },
              }))
            }
            disabled={checkDisable("vExpiry")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <FileUpload
            label={"PassPort"}
            {...uploadProps("passportFile")}
            onChange={(data) => setPassportFile(data.urls)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <FileUpload
            label={"Visa"}
            {...uploadProps("visaFile")}
            onChange={(data) => setVisaFile(data.urls)}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <FileUpload
            label={"Resume"}
            {...uploadProps("resume")}
            onChange={(data) => setResume(data.urls)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <FileUpload
            label={"Emirates ID"}
            {...uploadProps("emiratesId")}
            onChange={(data) => setEmiratesId(data.urls)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <FileUpload
            label={"Pancard"}
            {...uploadProps("pancard")}
            onChange={(data) => setPancard(data.urls)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <FileUpload
            label={"Aabhar Card"}
            {...uploadProps("aadharCard")}
            onChange={(data) => setAadharCard(data.urls)}
          />
        </Grid>
      </Grid>
      <Grid container rowSpacing={4} columnSpacing={4} mt={2}>
        <Grid item xs={12} sm={12} md={12}>
          <Typography
            sx={{
              color: "#202020",
              fontSize: "20px",
              fontWeight: "600",
            }}
          >
            Qualification Certificate
          </Typography>
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <FileUpload
            label={"SSC Certificate"}
            {...uploadProps("sscDuc")}
            onChange={(data) => setSscDuc(data.urls)}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <FileUpload
            label={"HSC Certificate"}
            {...uploadProps("hscDuc")}
            onChange={(data) => setHscDuc(data.urls)}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <FileUpload
            label={"Degree Certificate"}
            {...uploadProps("degreeCertificate")}
            onChange={(data) => SetDegreeCertificate(data.urls)}
          />
        </Grid>
      </Grid>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mt: 2,
          "@media(max-width:  600px)": {
            gap: 2,
          },
        }}
      >
        <CustomBottom
          onClick={onPrev}
          hoverColor={{ backgroundColor: "#8F9BB3" }}
          style={{
            marginTop: "2rem",
            width: "25%",
            backgroundColor: "#8F9BB3",
            "@media(max-width: 900px)": {
              width: "40%",
              "@media(max-width: 600px)": {
                width: "90%",
              },
            },
          }}
        >
          Previous
        </CustomBottom>
        <CustomBottom
          style={{
            marginTop: "2rem",
            width: "25%",
            "@media(max-width: 900px)": {
              width: "40%",
              "@media(max-width: 600px)": {
                justifyContent: "center",
                width: "90%",
              },
            },
          }}
          onClick={handleSummit}
          loading={loading}
          disabled={loading || uploadBlocked}
        >
          Submit
        </CustomBottom>
      </Box>
    </>
  );
};

export default UserIdProof;
